module.exports = __webpack_public_path__ + "media/images/flags/1x1/msr-c867d182a727b6472664f4e750fd8287.svg";